// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const IdeaPermissions = zod.object({
  "can_change_industry": zod.boolean(),
  "can_rerun": zod.boolean(),
  "can_triage": zod.boolean()
});

export type IdeaPermissions = zod.input<typeof IdeaPermissions>;
export type IdeaPermissionsOutput = zod.output<typeof IdeaPermissions>;
